import { lazy } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';
import MinimalLayout from 'layout/MinimalLayout';

// login option 3 routing
const Login = Loadable(lazy(() => import('views/Authentication/Auth/Login')));
const AuthRegister = Loadable(lazy(() => import('views/Authentication/Auth/Register')));
const GitHubOAuth = Loadable(lazy(() => import('views/Authentication/Auth/GitHubOAuth')));
const LarkOAuth = Loadable(lazy(() => import('views/Authentication/Auth/LarkOAuth')));
const OidcOAuth = Loadable(lazy(() => import('views/Authentication/Auth/OidcOAuth')));
const ForgetPassword = Loadable(lazy(() => import('views/Authentication/Auth/ForgetPassword')));
const ResetPassword = Loadable(lazy(() => import('views/Authentication/Auth/ResetPassword')));
const Home = Loadable(lazy(() => import('views/Home')));
const Download = Loadable(lazy(() => import('views/Download')));
const NotFoundView = Loadable(lazy(() => import('views/Error')));
const Agreement = Loadable(lazy(() => import('views/Agreement')));
const Privacy = Loadable(lazy(() => import('views/Privacy')));
const Contact = Loadable(lazy(() => import('views/Contact')));
const About = Loadable(lazy(() => import('views/About')));
const Price = Loadable(lazy(() => import('views/Price')));
const Ucodex = Loadable(lazy(() => import('views/Ucodex')));
const Ucrab = Loadable(lazy(() => import('views/Ucrab')));
const Usky = Loadable(lazy(() => import('views/Usky')));
const Models = Loadable(lazy(() => import('views/Models')));
const News = Loadable(lazy(() => import('views/News')));
const NewsDetail = Loadable(lazy(() => import('views/News/NewsDetail')));
const Platform = Loadable(lazy(() => import('views/Platform')));

const OtherRoutes = {
  path: '/',
  element: <MinimalLayout />,
  children: [
    {
      path: '/',
      element: <Home />
    },
    {
      path: '/home',
      element: <Home />
    },
    {
      path: '/download',
      element: <Download />
    },
    {
      path: '/login',
      element: <Login />
    },
    {
      path: '/register',
      element: <AuthRegister />
    },
    {
      path: '/news',
      element: <News />
    },
    {
      path: '/news/:id',
      element: <NewsDetail />
    },
    {
      path: '/agreement',
      element: <Agreement />
    },
    {
      path: '/privacy',
      element: <Privacy />
    },
    {
      path: '/contact',
      element: <Contact />
    },
    {
      path: '/about',
      element: <About />
    },
    {
      path: '/price',
      element: <Price />
    },
    {
      path: '/ucodex',
      element: <Ucodex />
    },
    {
      path: '/ucrab',
      element: <Ucrab />
    },
    {
      path: '/usky',
      element: <Usky />
    },
    {
      path: '/models',
      element: <Models />
    },
    {
      path: '/platform',
      element: <Platform />
    },
    {
      path: '/oauth/github',
      element: <GitHubOAuth />
    },
    {
      path: '/oauth/lark',
      element: <LarkOAuth />
    },
    {
      path: '/oidc/oauth',
      element: <OidcOAuth />
    },
    {
      path: '/forget',
      element: <ForgetPassword />
    },
    {
      path: '/reset',
      element: <ResetPassword />
    },
    {
      path: '/404',
      element: <NotFoundView />
    }
  ]
};

export default OtherRoutes;
